import { deleteSession } from 'src/libs/wa/gateways/api/sessionApi';
import { fetchRegisteredVia, fetchUser, fetchUserNickname } from 'src/libs/wa/gateways/api/userApi';
import { UserStore } from '../stores/UserStore';
import { userTranslator } from '../translators/userTranslator';

export class UserRepository {
  private userStore = new UserStore();

  public async fetchUser() {
    const userResponse = await fetchUser();
    const registeredViaResponse = await fetchRegisteredVia();
    const userNicknameResponse = await fetchUserNickname();
    if (userResponse !== null) {
      const user = userTranslator(userResponse, userNicknameResponse, registeredViaResponse);

      return user;
    }
  }

  public async delete() {
    await deleteSession();
    this.userStore.clear();
  }
}
